import { useState, useCallback } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleFormSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('phone_alt') as string || '').trim();
    if (honeypotValue) {
      setFormStatus('success');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9qu2b7nahb7382ovfvg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && (parsed as { code?: string }).code === 'OK') {
        setFormStatus('success');
        setFormError('');
        form.reset();
      } else {
        const serverMsg = (parsed as { meta?: { message?: string; detail?: string }; message?: string }).meta?.message
          || (parsed as { meta?: { message?: string; detail?: string }; message?: string }).meta?.detail
          || (parsed as { message?: string }).message
          || responseText;
        setFormStatus('error');
        setFormError(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查您的网络连接后重试');
    }
  }, []);
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 黄页网站免费入口91',
    description: '黄页网站免费入口91致力于为企业提供免费的企业信息发布平台，助力中小企业提升品牌曝光度和搜索排名。',
    url: 'https://www.huangye91.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '黄页网站免费入口91',
      url: 'https://www.huangye91.com',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '黄页网站免费入口91是什么平台？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黄页网站免费入口91是一个免费的企业信息在线收录和展示平台，帮助中小企业发布公司信息、提升网络曝光度、获取更多商业机会。',
        },
      },
      {
        '@type': 'Question',
        name: '在黄页网站免费入口91收录企业信息是否免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '完全免费。黄页网站免费入口91承诺永久免费为企业提供基本信息收录服务，不会向企业收取任何费用。',
        },
      },
      {
        '@type': 'Question',
        name: '收录后多久能在平台上显示？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '企业信息提交后，我们会在1-2个工作日内完成审核，审核通过后即可在平台上公开展示。',
        },
      },
      {
        '@type': 'Question',
        name: '可以修改已收录的企业信息吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '可以。企业在收录后如需修改信息，可以通过平台提供的联系方式与我们取得联系，我们会协助您完成信息更新。',
        },
      },
      {
        '@type': 'Question',
        name: '黄页收录对企业SEO有帮助吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的。在线黄页平台通常具有较高的域名权重，企业在平台上的信息页面能在搜索引擎中获得较好的排名，有助于提升企业品牌的搜索曝光度。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="bg-background-100 border-b border-background-200/70">
            <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
              <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
              <h1 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                关于我们
              </h1>
            </div>
          </div>

          <section className="max-w-4xl mx-auto px-4 md:px-6 py-14">
            <div className="prose prose-sm md:prose-base max-w-none text-foreground-700">
              <h2 className="text-xl font-bold text-foreground-900 font-heading">品牌介绍</h2>
              <p className="leading-relaxed">
                黄页网站免费入口91成立于2020年，是国内领先的免费企业信息在线收录平台。我们致力于为全国中小企业提供便捷、高效的企业信息发布和展示服务，帮助企业以最低的成本获得最大的在线曝光机会。
              </p>
              <p className="leading-relaxed">
                平台目前已收录超过10,000家企业信息，涵盖餐饮美食、建筑装修、教育培训、医疗健康、家居生活、汽车交通、旅游酒店、服装时尚、科技互联网、法律咨询、金融保险、物流快递等12大行业类别，为全国用户提供便捷的企业查询服务。
              </p>
              <p className="leading-relaxed">
                我们始终坚持以用户为中心，不断优化平台功能和用户体验，为企业提供更好的展示效果，为用户提供更精准的搜索服务。让每一家优秀的企业都能被看见，让每一次商业合作都更加高效——这是黄页网站免费入口91不变的使命。
              </p>
            </div>
          </section>

          <section className="bg-background-100 py-14">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="text-xl font-bold text-foreground-900 font-heading text-center mb-10">
                平台信誉
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-accent-500 font-heading">10,000+</div>
                  <p className="mt-2 text-sm text-foreground-600">收录企业</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-accent-500 font-heading">12</div>
                  <p className="mt-2 text-sm text-foreground-600">行业分类</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-accent-500 font-heading">500万+</div>
                  <p className="mt-2 text-sm text-foreground-600">月均查询量</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-accent-500 font-heading">98%</div>
                  <p className="mt-2 text-sm text-foreground-600">用户满意度</p>
                </div>
              </div>
            </div>
          </section>

          <section className="max-w-4xl mx-auto px-4 md:px-6 py-14">
            <h2 className="text-xl font-bold text-foreground-900 font-heading mb-6">联系我们</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-phone-line text-lg text-primary-500"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">客服电话</h3>
                    <p className="text-sm text-foreground-600 mt-0.5">400-000-8888</p>
                    <p className="text-xs text-foreground-500 mt-0.5">工作日 9:00 - 18:00</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-mail-line text-lg text-primary-500"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">电子邮箱</h3>
                    <p className="text-sm text-foreground-600 mt-0.5">service@huangye91.com</p>
                    <p className="text-xs text-foreground-500 mt-0.5">商务合作：biz@huangye91.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-map-pin-line text-lg text-primary-500"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">公司地址</h3>
                    <p className="text-sm text-foreground-600 mt-0.5">北京市朝阳区建国路88号SOHO现代城A座15层</p>
                  </div>
                </div>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-4">在线留言</h3>
                <form className="space-y-3" data-readdy-form="" onSubmit={handleFormSubmit}>
                  <input
                    type="text"
                    name="name"
                    placeholder="您的姓名"
                    required
                    className="w-full px-4 py-2.5 text-sm border border-background-200/70 rounded-lg bg-background-50 outline-none focus:border-primary-300 transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="您的邮箱"
                    required
                    className="w-full px-4 py-2.5 text-sm border border-background-200/70 rounded-lg bg-background-50 outline-none focus:border-primary-300 transition-colors"
                  />
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <textarea
                    name="message"
                    placeholder="请输入您的留言内容..."
                    rows={4}
                    maxLength={500}
                    required
                    className="w-full px-4 py-2.5 text-sm border border-background-200/70 rounded-lg bg-background-50 outline-none focus:border-primary-300 transition-colors resize-none"
                  ></textarea>
                  <button
                    type="submit"
                    className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    提交留言
                  </button>
                  {formStatus === 'success' && (
                    <p className="text-xs text-accent-600 text-center">留言提交成功，我们会尽快与您联系！</p>
                  )}
                  {formStatus === 'error' && (
                    <p className="text-xs text-red-500 text-center">{formError}</p>
                  )}
                </form>
              </div>
            </div>
          </section>

          <section className="bg-background-100 py-14">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="text-xl font-bold text-foreground-900 font-heading mb-6">常见问题</h2>
              <div className="space-y-4">
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                  <h3 className="text-sm font-semibold text-foreground-900">
                    黄页网站免费入口91是什么平台？
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    黄页网站免费入口91是一个免费的企业信息在线收录和展示平台，帮助中小企业发布公司信息、提升网络曝光度、获取更多商业机会。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                  <h3 className="text-sm font-semibold text-foreground-900">
                    收录企业信息是否收费？
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    完全免费。黄页网站免费入口91承诺永久免费为企业提供基本信息收录服务，不收取任何费用。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                  <h3 className="text-sm font-semibold text-foreground-900">
                    收录后多久能显示？
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    企业信息提交后，我们会在1-2个工作日内完成审核，审核通过后即可在平台上公开展示。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                  <h3 className="text-sm font-semibold text-foreground-900">
                    可以修改已收录的信息吗？
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    可以。企业如需修改信息，可通过平台提供的联系方式与我们取得联系，我们会协助您完成信息更新。
                  </p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                  <h3 className="text-sm font-semibold text-foreground-900">
                    黄页收录对SEO有帮助吗？
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    是的。在线黄页平台通常具有较高的域名权重，能有效提升企业品牌在搜索引擎中的曝光度和排名。
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}